import React, { useState } from "react";
import { Link } from "react-router-dom";
import Data from "../Data";

export default function AllGrocery() {
  const data = Data.Televison;

  const [searchInput, setsearchInput] = useState("");
  console.log(searchInput);

  const Searchedfiles = Data.Televison.filter((i) => {
    // console.log(i.name);
    return i.name.toLowerCase().includes(searchInput.toLowerCase());
  });

  const [proValues, setProValues] = useState({});

  const Prodv = (value) => {
    setProValues({
      ...proValues,
      Newvalue: value,
    });
  };

  const [sortHigh, setSortHigh] = useState(data);

  const sortPrice = () => {
    console.log("ji");
    const sorted = sortHigh.sort((a, b) => {
      return b.price - a.price;
    });
    setSortHigh(sorted);
  };
  console.log(sortHigh);

  // const sorted = [...sortHigh].sort((a, b) => {
  //   return b.price - a.price;
  // });

  return (
    <div className="container-fluid alltelevision">
      <h2 className="m-3 text-center">Television</h2>
      <div className="row">
        <div className="col-md-6 mt-3">
          <input
            type=""
            name=""
            id=""
            placeholder="Search what you want !"
            className="form-control"
            onChange={(e) => {
              setsearchInput(e.target.value);
            }}
          />
        </div>
        <div className="col-md-6 mt-3">
          <select id="inputState" class="form-control">
            <option selected>Sort By</option>
            <option>Revelence</option>
            <option onClick={sortPrice}>Price : Low to High</option>
            <option>Price : High to Low</option>
          </select>
        </div>
      </div>

      {Searchedfiles.length === 0 ? (
        <h4 className="oops">OOPS ! No result found</h4>
      ) : (
        <div className="container-fluid">
          <div
            class="modal fade "
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-body">
                  {/* <h3>{prod}</h3> */}
                  <h3 className="model-prod-desc">Product Descriptions</h3>
                  <h5>{proValues.Newvalue}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {Searchedfiles.map((product) => (
              <div key={product.id} className="allgroc">
                <Link
                  to={{
                    pathname: `ProductView/${product.name}`,
                    values: {
                      id: product.id,
                      name: product.name,
                      price: product.price,
                      originalprice: product.originalprice,
                      image: product.image,
                      description: product.desc,
                      rating: product.rating,
                      quantity: product.quantity,
                      weight: product.weight,
                      availableoffer: product.availableoffer,
                    },
                  }}
                  showInfo={product}
                  className="allgroc-name"
                >
                  <img
                    className="allgroc-img img-fluid"
                    src={product.image}
                    alt=""
                  />
                  <br />
                  <h6>{product.name}</h6>
                  <h6>{product.weight}</h6>
                  <div className="row mt-2">
                    <div className="col-5">
                      <h6 className="allgroc-price">₹{product.price}</h6>
                    </div>
                    <div className="col">
                      <h6 className="allgroc-org-price">
                        ₹{product.originalprice}
                      </h6>
                    </div>
                  </div>
                </Link>
                <div className="row">
                  <div className="col text-center">
                    <button
                      type="button"
                      className="btn-sm allgroc-view btn  "
                      data-toggle="modal"
                      data-target="#exampleModal"
                      onClick={() => Prodv(product.desc)}
                    >
                      Quick View
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
